
export const capitalize = (str) => str.substring(0, 1).toUpperCase() + str.substring(1).toLowerCase();

export const capitalizeFirst = (str) => str.substring(0, 1).toUpperCase() + str.substring(1);
